import { makeStyles } from "@material-ui/core";

export const usePricingCalculatorStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    toggleButtonGroup: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(0.25),
        '& .MuiToggleButtonGroup-grouped': {
            border: 'none',
            borderRadius: theme.shape.borderRadius,
            margin: 0,
            '&:not(:first-child)': {
                marginLeft: theme.spacing(0.5),
            },
        },
        '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontSize: '0.75rem',
            padding: theme.spacing(0.5, 1.5),
            color: theme.palette.text.primary,
            backgroundColor: 'transparent',
            '&.Mui-selected': {
                backgroundColor: theme.palette.common.white,
                fontWeight: 500,
            },
        },
    },
    inputItem: {
        '& input::placeholder': {
            color: theme.palette.common.darkText,
            opacity: 1,
        },
        '& .MuiInputBase-root.Mui-disabled': {
            opacity: 1,
            backgroundColor: theme.palette.background.default,
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: theme.palette.text.primary,
            WebkitTextFillColor: theme.palette.text.primary,
        },
    },
    priceInput: {
        '& .MuiInputBase-root': {
            border: `1px solid ${theme.palette.warning.main}`,
        },
    },
    marginInput: {
        '& .MuiInputBase-root': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    chargeInput: {
        '& .MuiInputBase-root': {
            border: `1px solid ${theme.palette.success.main}`,
        },
    },
    separator: {
        textAlign: 'center',
        fontSize: '1rem',
        color: theme.palette.text.secondary,
    },
    inputLabel: {
        color: theme.palette.text.secondary,
        margin: theme.spacing(0.2),
    },
    includingMaterials: {
        fontSize: '0.75rem',
        fontStyle: 'italic',
        opacity: 0.8,
    },
    materialsSection: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(0.5),
        backgroundColor: theme.palette.background.default,
    },
    materialsSectionWrapper: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    materialsSectionHeader: {
        fontSize: '0.85rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1),
    },
    materialRow: {
        marginBottom: theme.spacing(0.5),
        '& .MuiInputBase-root': {
            border: `1px solid ${theme.palette.warning.light}`,
        },
    },
    materialName: {
        fontSize: '0.85rem',
        color: theme.palette.text.primary,
        paddingRight: theme.spacing(1),
    },
    materialCostLabel: {
        fontSize: '0.7rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.25),
    },
    totalCostRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        paddingTop: theme.spacing(1),
        borderTop: `1px dashed ${theme.palette.divider}`,
        fontSize: '0.85rem',
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    totalCostValue: {
        fontWeight: 600,
        color: theme.palette.warning.dark,
    },
}));
